import Toastify from 'toastify-js';
import "toastify-js/src/toastify.css";
import axios from 'axios';

// Função para exibir Toast
const showToastify = (message) => {
  Toastify({
    text: message,
    duration: 4000,
    gravity: "top",
    position: "center",
    close: true,
    style: {
      background: "#AEFF00", 
      color: "black",
      borderRadius: "999px",
      padding: "12px 24px",
      fontFamily: "inherit",
      boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
    },
    className: "toastify-custom",
  }).showToast();
};

const form = () => {
  document.addEventListener("DOMContentLoaded", () => {
    // Abrir modal
    const btnAbrir = document.getElementById('abrir-modal-sugerir-tema');
    const btnFechar = document.getElementById('fechar-modal-sugerir-tema');
    const modal = document.getElementById('modal-sugerir-tema');

    if (btnAbrir && btnFechar && modal) {
      btnAbrir.addEventListener('click', (e) => {
        e.preventDefault();
        modal.classList.remove('hidden');
      });

      btnFechar.addEventListener('click', (e) => {
        e.preventDefault();
        modal.classList.add('hidden');
      });

      // Fechar modal ao clicar fora
      window.addEventListener('click', (e) => {
        if (e.target === modal) {
          modal.classList.add('hidden');
        }
      });
    }

    const formElement = document.getElementById('form-sugestao-conteudo');
    if (!formElement) return;

    formElement.addEventListener("submit", (e) => {
      e.preventDefault();

      const checkboxes = formElement.querySelectorAll('input[type="checkbox"].input-modal:checked');
      const interesses = Array.from(checkboxes).map(cb => cb.value);

      const temaInput = document.getElementById('input-tema-sugestao');
      const tema_sugestao = temaInput?.value.trim();

      if (interesses.length === 0 && !tema_sugestao) {
        showToastify("Selecione pelo menos um interesse ou escreva um tema específico.");
        return;
      }

      const formData = {
        interesses,
        tema_sugestao,
        codigo: 'sugestao_conteudo'
      };

      const btnSubmit = formElement.querySelector("button[type=submit]");
      if (btnSubmit) {
        btnSubmit.disabled = true;
        btnSubmit.classList.add("disabled");
      }

      axios.post("/sugestao-conteudo/", formData)
        .then(response => {
          const msg = response.data?.message || "Sugestão enviada com sucesso!";
          showToastify(msg);
          formElement.reset();
          modal.classList.add('hidden'); // Fecha o modal após enviar
        })
        .catch(error => {
          const msg = error.response?.data?.message || "Erro ao enviar a sugestão.";
          showToastify(msg);
        })
        .finally(() => {
          if (btnSubmit) {
            btnSubmit.disabled = false;
            btnSubmit.classList.remove("disabled");
          }
        });
    });
  });
};

export default form;
